import React, { useEffect, useMemo, useRef, useState } from "react";
import { Styles } from "./Tooltip.styles";
import { Content, displayConfiguration } from "./Content";
import { calculatePosition } from "../utils";
const Tooltip = ({
  classNames,
  showArrow = true,
  showIcon = false,
  direction = "bottom",
  persist = false,
  display,
  title,
  content,
  children,
  disallowPropagation = true
}) => {
  const tooltipRef = useRef(null);
  const contentRef = useRef(null);
  const leaveTimeoutRef = useRef(0);
  const [displayTooltip, setDisplayTooltip] = useState(false);
  const [persistOnClick, setPersistOnClick] = useState(false);
  const [position, setPosition] = useState({});
  const tooltipSettings = useMemo(() => ({ ...displayConfiguration, ...display }), [display]);
  const showTooltip = (e) => {
    if (disallowPropagation)
      e.stopPropagation();
    clearTimeout(leaveTimeoutRef.current);
    if (persistOnClick)
      return;
    setDisplayTooltip(true);
  };
  const hoverOffTooltip = (e) => {
    if (disallowPropagation)
      e.stopPropagation();
    leaveTimeoutRef.current = window.setTimeout(() => {
      setDisplayTooltip(false);
    }, 250);
  };
  const closeToolTip = (e) => {
    if (disallowPropagation)
      e.stopPropagation();
    setDisplayTooltip(false);
    setPersistOnClick(false);
  };
  const setPersistTooltip = (e) => {
    if (disallowPropagation)
      e.stopPropagation();
    showTooltip(e);
    setPersistOnClick((v) => !v);
  };
  const clearHideTooltip = (e) => {
    if (disallowPropagation)
      e.stopPropagation();
    clearTimeout(leaveTimeoutRef.current);
  };
  useEffect(() => {
    function handleClickElsewhere(e) {
      if (contentRef.current?.contains(e.target))
        return;
      setDisplayTooltip(false);
      if (!tooltipRef.current?.contains(e.target)) {
        setPersistOnClick(false);
      }
    }
    if (displayTooltip) {
      document.addEventListener("click", handleClickElsewhere, true);
      setPosition(calculatePosition(direction, tooltipRef.current.getBoundingClientRect(), contentRef.current.getBoundingClientRect(), tooltipSettings));
    }
    return () => {
      document.removeEventListener("click", handleClickElsewhere);
      clearTimeout(leaveTimeoutRef.current);
    };
  }, [direction, displayTooltip, tooltipSettings]);
  return /* @__PURE__ */ React.createElement(Styles, {
    onMouseEnter: (e) => !(persist || persistOnClick) && showTooltip(e),
    onMouseLeave: (e) => !(persist || persistOnClick) && hoverOffTooltip(e),
    onClick: setPersistTooltip,
    ref: tooltipRef
  }, displayTooltip && /* @__PURE__ */ React.createElement(Content, {
    ...tooltipSettings,
    ...position,
    classNames,
    hoverCallback: clearHideTooltip,
    persist,
    showArrow,
    showIcon,
    direction,
    closeCallback: closeToolTip,
    ref: contentRef,
    title,
    content
  }), children);
};
export default Tooltip;
export {};
